import type { IssueDefinition } from "../../issue-definition";
import { ISSUE_CATEGORY } from "../../issue-enums";

/**
 * The organization's Vibe consumption crossed a soft cap this billing period,
 * and the cost-safety sweep flipped it OK → WARNING.
 *
 * One row per organization, because the state machine is per organization: it
 * flips once, on whichever usage type crossed first. The row is open exactly
 * while the organization sits in WARNING — the sweep resolves it by set
 * difference against the WARNING set every tick, so the period rollover that
 * resets a stale WARNING, an admin moving the org by hand, and anything else
 * that takes it out of WARNING all close it.
 *
 * Not paged. The customer's own admins are emailed by the same sweep when it
 * flips the organization into WARNING, a soft
 * limit never suspends anything, and nothing worsens by the minute — this row is
 * the internal record of a spend signal, not an incident.
 */
export const VIBE_COST_SAFETY_SOFT_LIMIT_CROSSED = {
  category: ISSUE_CATEGORY.BILLING,
  message:
    "This organization's Vibe consumption crossed its soft cap for the billing period, and its cost-safety state moved to WARNING. Nothing was suspended — a soft limit only warns. The sweep emails the organization's admins once, at the moment it moves the organization into WARNING; a row opened for an organization that was already in WARNING says nothing about whether anyone was emailed. rawPayload carries a usage type that is over its cap, that type's sum this period, the cap and the period, refreshed on every sweep while a cap is crossed. Cleared automatically when the organization leaves WARNING, which the period rollover does by itself.",
  severity: "medium",
  remedy:
    "Nothing is broken; this is a spend signal. Decide with the account owner whether the cap should move or the usage is expected. The usage type, the sum and the effective cap are on rawPayload; the per-type caps are on the organization's Vibe consumption caps. SUSPENDED is a manual admin decision and is never applied by this sweep."
} as const satisfies IssueDefinition;
